import { Typography as AntdTypography } from "antd";
import React, { ReactNode } from "react";
import { TypographyProps as AntdTypographyProps } from "antd/es/typography";

export interface MyTypographyProps extends AntdTypographyProps {
  children?: ReactNode;
}

export interface TypographyStaticMethods {
  Text: typeof AntdTypography.Text;
  Title: typeof AntdTypography.Title;
  Paragraph: typeof AntdTypography.Paragraph;
}

const TypographyPolyfill: React.FC<MyTypographyProps> &
  TypographyStaticMethods = ({ children, ...props }) => {
  return <AntdTypography {...props}>{children}</AntdTypography>;
};

TypographyPolyfill.Text = AntdTypography.Text;
TypographyPolyfill.Title = AntdTypography.Title;
TypographyPolyfill.Paragraph = AntdTypography.Paragraph;

export default TypographyPolyfill;
